// Every glyph comes from Lucide (https://lucide.dev, ISC license).
// Keep this list sorted. See ../README.md before adding an icon.

import {
  Activity as LucideActivity,
  ArrowDownUp as LucideArrowDownUp,
  ArrowLeftRight as LucideArrowLeftRight,
  ArrowRight as LucideArrowRight,
  ArrowUpRight as LucideArrowUpRight,
  BadgeInfo as LucideBadgeInfo,
  Ban as LucideBan,
  Book as LucideBook,
  BookMarked as LucideBookMarked,
  BookOpen as LucideBookOpen,
  Bookmark as LucideBookmark,
  Box as LucideBox,
  Braces as LucideBraces,
  BringToFront as LucideBringToFront,
  Building2 as LucideBuilding2,
  Cable as LucideCable,
  Calendar as LucideCalendar,
  CalendarDays as LucideCalendarDays,
  ChartArea as LucideChartArea,
  ChartColumn as LucideChartColumn,
  ChartSpline as LucideChartSpline,
  Check as LucideCheck,
  ChevronDown as LucideChevronDown,
  ChevronLeft as LucideChevronLeft,
  ChevronRight as LucideChevronRight,
  ChevronUp as LucideChevronUp,
  ChevronsRight as LucideChevronsRight,
  ChevronsUpDown as LucideChevronsUpDown,
  CircleCheck as LucideCircleCheck,
  CircleChevronRight as LucideCircleChevronRight,
  CircleDashed as LucideCircleDashed,
  CirclePlay as LucideCirclePlay,
  CircleQuestionMark as LucideCircleQuestionMark,
  CircleX as LucideCircleX,
  Clipboard as LucideClipboard,
  ClipboardCheck as LucideClipboardCheck,
  Clock as LucideClock,
  ClockFading as LucideClockFading,
  Cloud as LucideCloud,
  CloudUpload as LucideCloudUpload,
  Code as LucideCode,
  Copy as LucideCopy,
  Cpu as LucideCpu,
  Database as LucideDatabase,
  Earth as LucideEarth,
  Ellipsis as LucideEllipsis,
  ExternalLink as LucideExternalLink,
  Eye as LucideEye,
  EyeOff as LucideEyeOff,
  FileCog as LucideFileCog,
  FileText as LucideFileText,
  Fingerprint as LucideFingerprint,
  Focus as LucideFocus,
  FolderCode as LucideFolderCode,
  FolderSymlink as LucideFolderSymlink,
  GitBranch as LucideGitBranch,
  GitCommitHorizontal as LucideGitCommitHorizontal,
  Grid2x2 as LucideGrid2x2,
  GripVertical as LucideGripVertical,
  Hammer as LucideHammer,
  HardDrive as LucideHardDrive,
  Hash as LucideHash,
  Heart as LucideHeart,
  HeartPulse as LucideHeartPulse,
  History as LucideHistory,
  Info as LucideInfo,
  Key as LucideKey,
  KeyRound as LucideKeyRound,
  Laptop as LucideLaptop,
  Layers as LucideLayers,
  Layers2 as LucideLayers2,
  Link as LucideLink,
  ListFilter as LucideListFilter,
  Lock as LucideLock,
  LockKeyhole as LucideLockKeyhole,
  Mail as LucideMail,
  MapPin as LucideMapPin,
  Maximize2 as LucideMaximize2,
  MemoryStick as LucideMemoryStick,
  Menu as LucideMenu,
  MessagesSquare as LucideMessagesSquare,
  Minimize2 as LucideMinimize2,
  Minus as LucideMinus,
  MoonStar as LucideMoonStar,
  Move as LucideMove,
  Network as LucideNetwork,
  PaintBucket as LucidePaintBucket,
  PanelLeftClose as LucidePanelLeftClose,
  PanelLeftOpen as LucidePanelLeftOpen,
  PenLine as LucidePenLine,
  Phone as LucidePhone,
  Plus as LucidePlus,
  RefreshCw as LucideRefreshCw,
  Rocket as LucideRocket,
  RotateCcw as LucideRotateCcw,
  Search as LucideSearch,
  Settings as LucideSettings,
  ShieldAlert as LucideShieldAlert,
  ShieldCheck as LucideShieldCheck,
  Shrink as LucideShrink,
  SlidersHorizontal as LucideSlidersHorizontal,
  Sparkles as LucideSparkles,
  Sprout as LucideSprout,
  SquareFunction as LucideSquareFunction,
  SquareMenu as LucideSquareMenu,
  SquareTerminal as LucideSquareTerminal,
  StickyNote as LucideStickyNote,
  Sun as LucideSun,
  Tag as LucideTag,
  Terminal as LucideTerminal,
  TextSearch as LucideTextSearch,
  Trash2 as LucideTrash2,
  TriangleAlert as LucideTriangleAlert,
  User as LucideUser,
  UserPlus as LucideUserPlus,
  UserSearch as LucideUserSearch,
  Variable as LucideVariable,
  Waypoints as LucideWaypoints,
  Workflow as LucideWorkflow,
  X as LucideX,
  Zap as LucideZap,
  ZapOff as LucideZapOff,
} from "lucide-react";
import { createIcon } from "./create-icon";

export const IconActivity = createIcon(LucideActivity, "IconActivity");
export const IconActivitySm = createIcon(LucideActivity, "IconActivitySm", "sm");
export const IconArrowLeftRight = createIcon(LucideArrowLeftRight, "IconArrowLeftRight");
export const IconArrowLeftRightSm = createIcon(LucideArrowLeftRight, "IconArrowLeftRightSm", "sm");
export const IconArrowRight = createIcon(LucideArrowRight, "IconArrowRight");
export const IconArrowRightSm = createIcon(LucideArrowRight, "IconArrowRightSm", "sm");
export const IconArrowUpRight = createIcon(LucideArrowUpRight, "IconArrowUpRight");
export const IconArrowUpRightSm = createIcon(LucideArrowUpRight, "IconArrowUpRightSm", "sm");
export const IconArrowsUpDown = createIcon(LucideArrowDownUp, "IconArrowsUpDown");
export const IconArrowsUpDownSm = createIcon(LucideArrowDownUp, "IconArrowsUpDownSm", "sm");
export const IconBan = createIcon(LucideBan, "IconBan");
export const IconBanSm = createIcon(LucideBan, "IconBanSm", "sm");
export const IconBolt = createIcon(LucideZap, "IconBolt");
export const IconBoltSm = createIcon(LucideZap, "IconBoltSm", "sm");
export const IconBoltOff = createIcon(LucideZapOff, "IconBoltOff");
export const IconBoltOffSm = createIcon(LucideZapOff, "IconBoltOffSm", "sm");
export const IconBook = createIcon(LucideBook, "IconBook");
export const IconBookSm = createIcon(LucideBook, "IconBookSm", "sm");
export const IconBookMarked = createIcon(LucideBookMarked, "IconBookMarked");
export const IconBookMarkedSm = createIcon(LucideBookMarked, "IconBookMarkedSm", "sm");
export const IconBookOpen = createIcon(LucideBookOpen, "IconBookOpen");
export const IconBookOpenSm = createIcon(LucideBookOpen, "IconBookOpenSm", "sm");
export const IconBookmark = createIcon(LucideBookmark, "IconBookmark");
export const IconBookmarkSm = createIcon(LucideBookmark, "IconBookmarkSm", "sm");
export const IconBox = createIcon(LucideBox, "IconBox");
export const IconBoxSm = createIcon(LucideBox, "IconBoxSm", "sm");
export const IconBraces = createIcon(LucideBraces, "IconBraces");
export const IconBracesSm = createIcon(LucideBraces, "IconBracesSm", "sm");
export const IconBringToFront = createIcon(LucideBringToFront, "IconBringToFront");
export const IconBringToFrontSm = createIcon(LucideBringToFront, "IconBringToFrontSm", "sm");
export const IconBucket = createIcon(LucidePaintBucket, "IconBucket");
export const IconBucketSm = createIcon(LucidePaintBucket, "IconBucketSm", "sm");
export const IconBuilding = createIcon(LucideBuilding2, "IconBuilding");
export const IconBuildingSm = createIcon(LucideBuilding2, "IconBuildingSm", "sm");
export const IconCable = createIcon(LucideCable, "IconCable");
export const IconCableSm = createIcon(LucideCable, "IconCableSm", "sm");
export const IconCalendar = createIcon(LucideCalendar, "IconCalendar");
export const IconCalendarSm = createIcon(LucideCalendar, "IconCalendarSm", "sm");
export const IconCalendarDays = createIcon(LucideCalendarDays, "IconCalendarDays");
export const IconCalendarDaysSm = createIcon(LucideCalendarDays, "IconCalendarDaysSm", "sm");
export const IconCaretDown = createIcon(LucideChevronDown, "IconCaretDown");
export const IconCaretDownSm = createIcon(LucideChevronDown, "IconCaretDownSm", "sm");
export const IconCaretRight = createIcon(LucideChevronRight, "IconCaretRight");
export const IconCaretRightSm = createIcon(LucideChevronRight, "IconCaretRightSm", "sm");
export const IconCaretUp = createIcon(LucideChevronUp, "IconCaretUp");
export const IconCaretUpSm = createIcon(LucideChevronUp, "IconCaretUpSm", "sm");
export const IconChartBar = createIcon(LucideChartColumn, "IconChartBar");
export const IconChartBarSm = createIcon(LucideChartColumn, "IconChartBarSm", "sm");
export const IconChartLine = createIcon(LucideChartSpline, "IconChartLine");
export const IconChartLineSm = createIcon(LucideChartSpline, "IconChartLineSm", "sm");
export const IconChats = createIcon(LucideMessagesSquare, "IconChats");
export const IconChatsSm = createIcon(LucideMessagesSquare, "IconChatsSm", "sm");
export const IconCheck = createIcon(LucideCheck, "IconCheck");
export const IconCheckSm = createIcon(LucideCheck, "IconCheckSm", "sm");
export const IconChevronDown = createIcon(LucideChevronDown, "IconChevronDown");
export const IconChevronDownSm = createIcon(LucideChevronDown, "IconChevronDownSm", "sm");
export const IconChevronLeft = createIcon(LucideChevronLeft, "IconChevronLeft");
export const IconChevronLeftSm = createIcon(LucideChevronLeft, "IconChevronLeftSm", "sm");
export const IconChevronRight = createIcon(LucideChevronRight, "IconChevronRight");
export const IconChevronRightSm = createIcon(LucideChevronRight, "IconChevronRightSm", "sm");
export const IconChevronUp = createIcon(LucideChevronUp, "IconChevronUp");
export const IconChevronUpSm = createIcon(LucideChevronUp, "IconChevronUpSm", "sm");
export const IconChevronsRight = createIcon(LucideChevronsRight, "IconChevronsRight");
export const IconChevronsRightSm = createIcon(LucideChevronsRight, "IconChevronsRightSm", "sm");
export const IconChevronsUpDown = createIcon(LucideChevronsUpDown, "IconChevronsUpDown");
export const IconChevronsUpDownSm = createIcon(LucideChevronsUpDown, "IconChevronsUpDownSm", "sm");
export const IconCircleCheck = createIcon(LucideCircleCheck, "IconCircleCheck");
export const IconCircleCheckSm = createIcon(LucideCircleCheck, "IconCircleCheckSm", "sm");
export const IconCircleChevronRight = createIcon(
  LucideCircleChevronRight,
  "IconCircleChevronRight",
);
export const IconCircleChevronRightSm = createIcon(
  LucideCircleChevronRight,
  "IconCircleChevronRightSm",
  "sm",
);
export const IconCircleDashed = createIcon(LucideCircleDashed, "IconCircleDashed");
export const IconCircleDashedSm = createIcon(LucideCircleDashed, "IconCircleDashedSm", "sm");
export const IconCirclePlay = createIcon(LucideCirclePlay, "IconCirclePlay");
export const IconCirclePlaySm = createIcon(LucideCirclePlay, "IconCirclePlaySm", "sm");
export const IconCircleX = createIcon(LucideCircleX, "IconCircleX");
export const IconCircleXSm = createIcon(LucideCircleX, "IconCircleXSm", "sm");
export const IconClipboard = createIcon(LucideClipboard, "IconClipboard");
export const IconClipboardSm = createIcon(LucideClipboard, "IconClipboardSm", "sm");
export const IconClipboardCheck = createIcon(LucideClipboardCheck, "IconClipboardCheck");
export const IconClipboardCheckSm = createIcon(LucideClipboardCheck, "IconClipboardCheckSm", "sm");
export const IconClock = createIcon(LucideClock, "IconClock");
export const IconClockSm = createIcon(LucideClock, "IconClockSm", "sm");
export const IconClockFading = createIcon(LucideClockFading, "IconClockFading");
export const IconClockFadingSm = createIcon(LucideClockFading, "IconClockFadingSm", "sm");
export const IconCloud = createIcon(LucideCloud, "IconCloud");
export const IconCloudSm = createIcon(LucideCloud, "IconCloudSm", "sm");
export const IconCloudUpload = createIcon(LucideCloudUpload, "IconCloudUpload");
export const IconCloudUploadSm = createIcon(LucideCloudUpload, "IconCloudUploadSm", "sm");
export const IconCode = createIcon(LucideCode, "IconCode");
export const IconCodeSm = createIcon(LucideCode, "IconCodeSm", "sm");
export const IconCopy = createIcon(LucideCopy, "IconCopy");
export const IconCopySm = createIcon(LucideCopy, "IconCopySm", "sm");
export const IconCpu = createIcon(LucideCpu, "IconCpu");
export const IconCpuSm = createIcon(LucideCpu, "IconCpuSm", "sm");
export const IconDatabase = createIcon(LucideDatabase, "IconDatabase");
export const IconDatabaseSm = createIcon(LucideDatabase, "IconDatabaseSm", "sm");
export const IconEllipsis = createIcon(LucideEllipsis, "IconEllipsis");
export const IconEllipsisSm = createIcon(LucideEllipsis, "IconEllipsisSm", "sm");
export const IconExternalLink = createIcon(LucideExternalLink, "IconExternalLink");
export const IconExternalLinkSm = createIcon(LucideExternalLink, "IconExternalLinkSm", "sm");
export const IconEye = createIcon(LucideEye, "IconEye");
export const IconEyeSm = createIcon(LucideEye, "IconEyeSm", "sm");
export const IconEyeOff = createIcon(LucideEyeOff, "IconEyeOff");
export const IconEyeOffSm = createIcon(LucideEyeOff, "IconEyeOffSm", "sm");
export const IconFile = createIcon(LucideFileText, "IconFile");
export const IconFileSm = createIcon(LucideFileText, "IconFileSm", "sm");
export const IconFileCog = createIcon(LucideFileCog, "IconFileCog");
export const IconFileCogSm = createIcon(LucideFileCog, "IconFileCogSm", "sm");
export const IconFilter = createIcon(LucideListFilter, "IconFilter");
export const IconFilterSm = createIcon(LucideListFilter, "IconFilterSm", "sm");
export const IconFingerprint = createIcon(LucideFingerprint, "IconFingerprint");
export const IconFingerprintSm = createIcon(LucideFingerprint, "IconFingerprintSm", "sm");
export const IconFocus = createIcon(LucideFocus, "IconFocus");
export const IconFocusSm = createIcon(LucideFocus, "IconFocusSm", "sm");
export const IconFolderCloud = createIcon(LucideFolderCode, "IconFolderCloud");
export const IconFolderCloudSm = createIcon(LucideFolderCode, "IconFolderCloudSm", "sm");
export const IconFolderSymlink = createIcon(LucideFolderSymlink, "IconFolderSymlink");
export const IconFolderSymlinkSm = createIcon(LucideFolderSymlink, "IconFolderSymlinkSm", "sm");
export const IconFunction = createIcon(LucideSquareFunction, "IconFunction");
export const IconFunctionSm = createIcon(LucideSquareFunction, "IconFunctionSm", "sm");
export const IconGitBranch = createIcon(LucideGitBranch, "IconGitBranch");
export const IconGitBranchSm = createIcon(LucideGitBranch, "IconGitBranchSm", "sm");
export const IconGitCommit = createIcon(LucideGitCommitHorizontal, "IconGitCommit");
export const IconGitCommitSm = createIcon(LucideGitCommitHorizontal, "IconGitCommitSm", "sm");
export const IconGlobe = createIcon(LucideEarth, "IconGlobe");
export const IconGlobeSm = createIcon(LucideEarth, "IconGlobeSm", "sm");
export const IconGrid = createIcon(LucideGrid2x2, "IconGrid");
export const IconGridSm = createIcon(LucideGrid2x2, "IconGridSm", "sm");
export const IconGrip = createIcon(LucideGripVertical, "IconGrip");
export const IconGripSm = createIcon(LucideGripVertical, "IconGripSm", "sm");
export const IconHammer = createIcon(LucideHammer, "IconHammer");
export const IconHammerSm = createIcon(LucideHammer, "IconHammerSm", "sm");
export const IconHardDrive = createIcon(LucideHardDrive, "IconHardDrive");
export const IconHardDriveSm = createIcon(LucideHardDrive, "IconHardDriveSm", "sm");
export const IconHash = createIcon(LucideHash, "IconHash");
export const IconHashSm = createIcon(LucideHash, "IconHashSm", "sm");
export const IconHeart = createIcon(LucideHeart, "IconHeart");
export const IconHeartSm = createIcon(LucideHeart, "IconHeartSm", "sm");
export const IconHeartPulse = createIcon(LucideHeartPulse, "IconHeartPulse");
export const IconHeartPulseSm = createIcon(LucideHeartPulse, "IconHeartPulseSm", "sm");
export const IconHelp = createIcon(LucideCircleQuestionMark, "IconHelp");
export const IconHelpSm = createIcon(LucideCircleQuestionMark, "IconHelpSm", "sm");
export const IconHistory = createIcon(LucideHistory, "IconHistory");
export const IconHistorySm = createIcon(LucideHistory, "IconHistorySm", "sm");
export const IconInfo = createIcon(LucideInfo, "IconInfo");
export const IconInfoSm = createIcon(LucideInfo, "IconInfoSm", "sm");
export const IconInfoSparkle = createIcon(LucideBadgeInfo, "IconInfoSparkle");
export const IconInfoSparkleSm = createIcon(LucideBadgeInfo, "IconInfoSparkleSm", "sm");
export const IconKey = createIcon(LucideKey, "IconKey");
export const IconKeySm = createIcon(LucideKey, "IconKeySm", "sm");
export const IconKeyRound = createIcon(LucideKeyRound, "IconKeyRound");
export const IconKeyRoundSm = createIcon(LucideKeyRound, "IconKeyRoundSm", "sm");
export const IconLaptop = createIcon(LucideLaptop, "IconLaptop");
export const IconLaptopSm = createIcon(LucideLaptop, "IconLaptopSm", "sm");
export const IconLayers = createIcon(LucideLayers, "IconLayers");
export const IconLayersSm = createIcon(LucideLayers, "IconLayersSm", "sm");
export const IconLayers2 = createIcon(LucideLayers2, "IconLayers2");
export const IconLayers2Sm = createIcon(LucideLayers2, "IconLayers2Sm", "sm");
export const IconLink = createIcon(LucideLink, "IconLink");
export const IconLinkSm = createIcon(LucideLink, "IconLinkSm", "sm");
export const IconListSquare = createIcon(LucideSquareMenu, "IconListSquare");
export const IconListSquareSm = createIcon(LucideSquareMenu, "IconListSquareSm", "sm");
export const IconLock = createIcon(LucideLock, "IconLock");
export const IconLockSm = createIcon(LucideLock, "IconLockSm", "sm");
export const IconLockKeyhole = createIcon(LucideLockKeyhole, "IconLockKeyhole");
export const IconLockKeyholeSm = createIcon(LucideLockKeyhole, "IconLockKeyholeSm", "sm");
export const IconMail = createIcon(LucideMail, "IconMail");
export const IconMailSm = createIcon(LucideMail, "IconMailSm", "sm");
export const IconMapPin = createIcon(LucideMapPin, "IconMapPin");
export const IconMapPinSm = createIcon(LucideMapPin, "IconMapPinSm", "sm");
export const IconMaximize = createIcon(LucideMaximize2, "IconMaximize");
export const IconMaximizeSm = createIcon(LucideMaximize2, "IconMaximizeSm", "sm");
export const IconMemory = createIcon(LucideMemoryStick, "IconMemory");
export const IconMemorySm = createIcon(LucideMemoryStick, "IconMemorySm", "sm");
export const IconMenu = createIcon(LucideMenu, "IconMenu");
export const IconMenuSm = createIcon(LucideMenu, "IconMenuSm", "sm");
export const IconMinimize = createIcon(LucideMinimize2, "IconMinimize");
export const IconMinimizeSm = createIcon(LucideMinimize2, "IconMinimizeSm", "sm");
export const IconMinus = createIcon(LucideMinus, "IconMinus");
export const IconMinusSm = createIcon(LucideMinus, "IconMinusSm", "sm");
export const IconMoon = createIcon(LucideMoonStar, "IconMoon");
export const IconMoonSm = createIcon(LucideMoonStar, "IconMoonSm", "sm");
export const IconMove = createIcon(LucideMove, "IconMove");
export const IconMoveSm = createIcon(LucideMove, "IconMoveSm", "sm");
export const IconNetwork = createIcon(LucideNetwork, "IconNetwork");
export const IconNetworkSm = createIcon(LucideNetwork, "IconNetworkSm", "sm");
export const IconNote = createIcon(LucideStickyNote, "IconNote");
export const IconNoteSm = createIcon(LucideStickyNote, "IconNoteSm", "sm");
export const IconPen = createIcon(LucidePenLine, "IconPen");
export const IconPenSm = createIcon(LucidePenLine, "IconPenSm", "sm");
export const IconPhone = createIcon(LucidePhone, "IconPhone");
export const IconPhoneSm = createIcon(LucidePhone, "IconPhoneSm", "sm");
export const IconPlus = createIcon(LucidePlus, "IconPlus");
export const IconPlusSm = createIcon(LucidePlus, "IconPlusSm", "sm");
export const IconRefresh = createIcon(LucideRefreshCw, "IconRefresh");
export const IconRefreshSm = createIcon(LucideRefreshCw, "IconRefreshSm", "sm");
export const IconRocket = createIcon(LucideRocket, "IconRocket");
export const IconRocketSm = createIcon(LucideRocket, "IconRocketSm", "sm");
export const IconRollback = createIcon(LucideRotateCcw, "IconRollback");
export const IconRollbackSm = createIcon(LucideRotateCcw, "IconRollbackSm", "sm");
export const IconRollbackPending = createIcon(LucideHistory, "IconRollbackPending");
export const IconRollbackPendingSm = createIcon(LucideHistory, "IconRollbackPendingSm", "sm");
export const IconSearch = createIcon(LucideSearch, "IconSearch");
export const IconSearchSm = createIcon(LucideSearch, "IconSearchSm", "sm");
export const IconSettings = createIcon(LucideSettings, "IconSettings");
export const IconSettingsSm = createIcon(LucideSettings, "IconSettingsSm", "sm");
export const IconShieldAlert = createIcon(LucideShieldAlert, "IconShieldAlert");
export const IconShieldAlertSm = createIcon(LucideShieldAlert, "IconShieldAlertSm", "sm");
export const IconShieldCheck = createIcon(LucideShieldCheck, "IconShieldCheck");
export const IconShieldCheckSm = createIcon(LucideShieldCheck, "IconShieldCheckSm", "sm");
export const IconShrink = createIcon(LucideShrink, "IconShrink");
export const IconShrinkSm = createIcon(LucideShrink, "IconShrinkSm", "sm");
export const IconSidebarClose = createIcon(LucidePanelLeftClose, "IconSidebarClose");
export const IconSidebarCloseSm = createIcon(LucidePanelLeftClose, "IconSidebarCloseSm", "sm");
export const IconSidebarOpen = createIcon(LucidePanelLeftOpen, "IconSidebarOpen");
export const IconSidebarOpenSm = createIcon(LucidePanelLeftOpen, "IconSidebarOpenSm", "sm");
export const IconSliders = createIcon(LucideSlidersHorizontal, "IconSliders");
export const IconSlidersSm = createIcon(LucideSlidersHorizontal, "IconSlidersSm", "sm");
export const IconSparkles = createIcon(LucideSparkles, "IconSparkles");
export const IconSparklesSm = createIcon(LucideSparkles, "IconSparklesSm", "sm");
export const IconSprout = createIcon(LucideSprout, "IconSprout");
export const IconSproutSm = createIcon(LucideSprout, "IconSproutSm", "sm");
export const IconSquareTerminal = createIcon(LucideSquareTerminal, "IconSquareTerminal");
export const IconSquareTerminalSm = createIcon(LucideSquareTerminal, "IconSquareTerminalSm", "sm");
export const IconSun = createIcon(LucideSun, "IconSun");
export const IconSunSm = createIcon(LucideSun, "IconSunSm", "sm");
export const IconTag = createIcon(LucideTag, "IconTag");
export const IconTagSm = createIcon(LucideTag, "IconTagSm", "sm");
export const IconTerminal = createIcon(LucideTerminal, "IconTerminal");
export const IconTerminalSm = createIcon(LucideTerminal, "IconTerminalSm", "sm");
export const IconTextSearch = createIcon(LucideTextSearch, "IconTextSearch");
export const IconTextSearchSm = createIcon(LucideTextSearch, "IconTextSearchSm", "sm");
export const IconTrash = createIcon(LucideTrash2, "IconTrash");
export const IconTrashSm = createIcon(LucideTrash2, "IconTrashSm", "sm");
export const IconUsage = createIcon(LucideChartArea, "IconUsage");
export const IconUsageSm = createIcon(LucideChartArea, "IconUsageSm", "sm");
export const IconUser = createIcon(LucideUser, "IconUser");
export const IconUserSm = createIcon(LucideUser, "IconUserSm", "sm");
export const IconUserPlus = createIcon(LucideUserPlus, "IconUserPlus");
export const IconUserPlusSm = createIcon(LucideUserPlus, "IconUserPlusSm", "sm");
export const IconUserSearch = createIcon(LucideUserSearch, "IconUserSearch");
export const IconUserSearchSm = createIcon(LucideUserSearch, "IconUserSearchSm", "sm");
export const IconVariable = createIcon(LucideVariable, "IconVariable");
export const IconVariableSm = createIcon(LucideVariable, "IconVariableSm", "sm");
export const IconWarning = createIcon(LucideTriangleAlert, "IconWarning");
export const IconWarningSm = createIcon(LucideTriangleAlert, "IconWarningSm", "sm");
export const IconWaypoints = createIcon(LucideWaypoints, "IconWaypoints");
export const IconWaypointsSm = createIcon(LucideWaypoints, "IconWaypointsSm", "sm");
export const IconWorkflow = createIcon(LucideWorkflow, "IconWorkflow");
export const IconWorkflowSm = createIcon(LucideWorkflow, "IconWorkflowSm", "sm");
export const IconX = createIcon(LucideX, "IconX");
export const IconXSm = createIcon(LucideX, "IconXSm", "sm");

export const IconBookmarkFilled = createIcon(LucideBookmark, "IconBookmarkFilled", "md", {
  fill: "currentColor",
});
